import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ClerkProvider } from '@clerk/react';
import { plPL } from '@clerk/localizations';
import App from './App';
import { LocaleProvider, useLocaleContext } from './i18n';

function ClerkWrapper({ children }: { children: React.ReactNode }) {
  const { lang } = useLocaleContext();
  return (
    <ClerkProvider
      publishableKey={process.env.REACT_APP_CLERK_PUBLISHABLE_KEY!}
      afterSignOutUrl="/"
      localization={lang === 'pl' ? plPL : undefined}
    >
      {children}
    </ClerkProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/:lang/*" element={
          <LocaleProvider>
            <ClerkWrapper>
              <App />
            </ClerkWrapper>
          </LocaleProvider>
        } />
        {/* Fallback dla głównej domeny (root) i błędnych ścieżek */}
        <Route path="*" element={
          <LocaleProvider>
            <ClerkWrapper>
              <App />
            </ClerkWrapper>
          </LocaleProvider>
        } />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
